export default "__VITE_ASSET__BhLtST$2__"